import type { DateTime } from "luxon";

/**
 * Rounds the given time to the nearest 5-minute mark,
 * considering both minutes and seconds.
 *
 * @param dateTime The Luxon DateTime object
 * @returns A new DateTime object rounded to the nearest 5 minutes
 */
export function roundToNearestFiveMinutes(dateTime: DateTime): DateTime {
  const minutes = dateTime.minute;
  const seconds = dateTime.second;

  // Calculate the remainder when dividing minutes by 5 (to find the last 5-minute mark)
  const remainder = minutes % 5;

  // Calculate the "elapsed time" since the last 5-minute mark
  const elapsed = remainder * 60 + seconds; // Convert minutes to seconds and add seconds

  // Round up if the elapsed time is 2 minutes 30 seconds or more, otherwise round down
  const shouldRoundUp = elapsed >= 2.5 * 60;

  // Round to the nearest 5-minute mark
  const roundedMinutes = shouldRoundUp
    ? minutes + (5 - remainder) // Round up to the next 5-minute mark
    : minutes - remainder; // Round down to the previous 5-minute mark

  // Set the rounded minutes, seconds, and milliseconds to 0
  return dateTime.set({ minute: roundedMinutes, second: 0, millisecond: 0 });
}
